import { Dispatch } from "redux";
import { CreateOrderModel } from "../../models/order-model";
import { API } from "../api/order-api";
import ORDER_CONSTANTS from "../constants/order-constants";
import * as types from "../types/order-types";

//---------------------------------- CREATE ORDER --------------------------------------------------
const createOrderRequest = (): types.ICreateOrderRequest => {
  return {
    type: ORDER_CONSTANTS.CREATE_ORDER_REQUEST,
  };
};

const createOrderFail = (e: any): types.ICreateOrderFail => {
  return {
    type: ORDER_CONSTANTS.CREATE_ORDER_FAIL,
    error: e,
  };
};

const createOrderSuccess = (orderCreated: any): types.ICreateOrderSuccess => {
  return {
    type: ORDER_CONSTANTS.CREATE_ORDER_SUCCESS,
    data: orderCreated,
  };
};

export const createOrder = (order: CreateOrderModel) => {
  return (dispatch: Dispatch) => {
    dispatch(createOrderRequest());
    API.createOrder(order)
      .then((response: any) => {
        dispatch(createOrderSuccess(response.data.data.order));
      })
      .catch((error: any) => {
        dispatch(
          createOrderFail(error.response.data.errors.productErrors || error)
        );
      });
  };
};

//---------------------------------- GET ORDERS BY CLIENT --------------------------------------------------
const getOrdersByClientRequest = () => {
  return {
    type: ORDER_CONSTANTS.GET_ORDERS_BY_CLIENT_REQUEST,
  };
};

const getOrdersByClientFail = (e: any) => {
  return {
    type: ORDER_CONSTANTS.GET_ORDERS_BY_CLIENT_FAIL,
    error: e,
  };
};

const getOrdersByClientSuccess = (data: any) => {
  return {
    type: ORDER_CONSTANTS.GET_ORDERS_BY_CLIENT_SUCCESS,
    data,
  };
};

export const getOrdersByClient = (
  page: number,
  limit: number,
  statusFilter: string[]
) => {
  return (dispatch: Dispatch) => {
    dispatch(getOrdersByClientRequest());
    API.getOrders(page, limit, statusFilter)
      .then((response: any) => {
        dispatch(getOrdersByClientSuccess(response.data));
      })
      .catch((error: any) => {
        dispatch(getOrdersByClientFail(error));
      });
  };
};

//---------------------------------- GET ORDER DETAIL--------------------------------------------------
const getOrderDetailBegin = (): types.IGetOrderDetailBegin => {
  return {
    type: ORDER_CONSTANTS.GET_ORDERDETAIL_BEGIN,
  };
};

const getOrderDetailError = (e: any): types.IGetOrderDetailError => {
  return {
    type: ORDER_CONSTANTS.GET_ORDERDETAIL_ERROR,
    error: e,
  };
};

const getOrderDetailSuccess = (data: any): types.IGetOrderDetailSuccess => {
  return {
    type: ORDER_CONSTANTS.GET_ORDERDETAIL_SUCCESS,
    data,
  };
};

export const getOrderDetail = (id: string) => {
  return (dispatch: Dispatch) => {
    dispatch(getOrderDetailBegin());
    API.getOrderDetail(id)
      .then((response: any) => {
        dispatch(getOrderDetailSuccess(response.data));
      })
      .catch((error: any) => {
        dispatch(getOrderDetailError(error.response));
      });
  };
};

//---------------------------------- GET ORDER DETAIL--------------------------------------------------
const cancelOrderBegin = (): types.ICancelOrderBegin => {
  return {
    type: ORDER_CONSTANTS.CANCEL_ORDER_BEGIN,
  };
};

const cancerlOrderError = (e: any): types.ICancelOrderError => {
  return {
    type: ORDER_CONSTANTS.CANCEL_ORDER_ERROR,
    error: e,
  };
};

const cancelOrderSuccess = (data: any): types.ICancelOrderSuccess => {
  return {
    type: ORDER_CONSTANTS.CANCEL_ORDER_SUCCESS,
    data,
  };
};

export const cancelOrder = (id: string, payload: any) => {
  return (dispatch: Dispatch) => {
    dispatch(cancelOrderBegin());
    API.updateOrder(id, payload)
      .then((response: any) => {
        dispatch(cancelOrderSuccess(response.data));
      })
      .catch((error: any) => {
        dispatch(cancerlOrderError(error.response));
      });
  };
};

const resetOrder = (): types.ICreateOrderReset => {
  return {
    type: ORDER_CONSTANTS.CREATE_ORDER_RESET,
  };
};

export const resetOrderStatus = () => {
  return (dispatch: Dispatch) => {
    dispatch(resetOrder());
  };
};
